import { apiGateway, apiSchemas } from "@smart/auth-resources-basic";
import { useApi, ApiResults } from "@smart/itops-hooks-dom";

export const authApi = useApi(
  apiGateway.prefix,
  apiGateway.lambdaKeys,
  apiGateway.lambdas,
  apiSchemas,
);

export type AuthApiResults = ApiResults<typeof authApi>;
